export default "be9a55aee5f10fb8.svg"